import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";
import logo from "../../assets/images/core_semi_logo.jpeg";

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="gy-4">
          <Col lg={4} md={6}>
            <div className="footer-about">
              <div className="footer-logo">
                <img src={logo} alt="Chip Mentors" />
                {/* <h5>Core Semicon Technologies</h5> */}
              </div>

              <p>
                Core Semicon Technologies prepares future semiconductor
                professionals through hands-on learning and real design
                challenges. Our programs mirror modern chip development needs,
                helping learners gain deep technical skills and practical
                confidence to succeed in fast-paced VLSI careers.
              </p>

              <h6>Follow Us On:</h6>
              <div className="social-icons">
                <a href="#">
                  <i className="fa-brands fa-facebook-f"></i>
                </a>
                <a href="#">
                  <i className="fa-brands fa-instagram"></i>
                </a>
                <a href="https://www.linkedin.com/company/coresemicon-technologies/?viewAsMember=true" target="_blank">
                  <i className="fa-brands fa-linkedin-in"></i>
                </a>
                <a href="#">
                  <i className="fa-brands fa-youtube"></i>
                </a>
              </div>
            </div>
          </Col>

          {/* USEFUL LINKS */}
          <Col lg={2} md={6}>
            <h5 className="footer-title">Useful Links</h5>
            <ul className="footer-links">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li>
                <NavLink to="/about">About Us</NavLink>
              </li>
              <li>
                <NavLink to="/courses">Courses</NavLink>
              </li>
              <li>
                <NavLink to="/careers">Careers</NavLink>
              </li>
              <li>
                <NavLink to="/contact">Contact</NavLink>
              </li>
            </ul>
          </Col>

          {/* RESOURCES */}
          <Col lg={3} md={6}>
            <h5 className="footer-title">Resources</h5>
            <ul className="footer-links">
              {/* <li><NavLink to="/interview-prep">Interview Prep</NavLink></li>
              <li><NavLink to="/blog">Blog & Articles</NavLink></li> */}
              <li>
                <NavLink to="/terms">Terms & Conditions</NavLink>
              </li>
            </ul>
          </Col>

          {/* CONTACT */}

          <Col lg={3} md={6}>
            <h5 className="footer-title">Contact Us</h5>
            <ul className="footer-contact">
              <li>
                <i className="fa-solid fa-location-dot"></i>
                <span>
                  No.202 , 3rd floor, 301 6th cross, aswath nagar, Marathahalli
                  Bangalore 560037
                </span>
              </li>

              <li>
                <i className="fa-solid fa-phone"></i>
              <span>+91 7022289866</span>
              </li>

              <li>
                <i className="fa-solid fa-envelope"></i>
                <span>hr@coresemicon.com</span>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>

      {/* COPYRIGHT */}
      <div className="footer-bottom">
        © 2026 Core Semicon Technologies. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
